import { getLatitudeAndLongitudeFor } from './LocationsGeoCoder.js';

const locationGeoCoderFactory = sdk => ({
  getLocation: (address, postalCode, city) => {
    if (address === '') {
      return sdk.v1.locations.postalCodes.getPostalCodeCoordinates(postalCode, city);
    }
    return getLatitudeAndLongitudeFor(address, postalCode).catch(() => sdk.v1.locations.postalCodes.getPostalCodeCoordinates(postalCode, city));
  }
});

export { locationGeoCoderFactory };
//# sourceMappingURL=LocationGeoCoderFactory.js.map
